import { render, staticRenderFns } from "./EdicionProductos.vue?vue&type=template&id=789d42f5"
import script from "./EdicionProductos.vue?vue&type=script&lang=js"
export * from "./EdicionProductos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports